module.exports = __webpack_public_path__ + "static/img/nenglihuaxiagn.6e82d087.png";